var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent w-full"},[_c('Card',{attrs:{"slide":_vm.slideTo,"display-type":"carousel","resources":_vm.resources,"title":this.settings.recent_resources_text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }